import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  
  const footerLinks = {
    product: {
      title: t('footer.product'),
      links: [
        { name: t('footer.links.features'), href: '/#features' },
        { name: t('footer.links.pricing'), href: '/#pricing' },
        { name: t('footer.links.faq'), href: '/faq' }
      ]
    },
    company: {
      title: t('footer.company'),
      links: [
        { name: t('footer.links.about'), href: '/#about' },
        { name: t('footer.links.blog'), href: '/blog' },
        { name: t('footer.links.careers'), href: '/careers' }
      ]
    },
    support: {
      title: t('footer.support'),
      links: [
        { name: t('footer.links.contact'), href: '/contact' },
        { name: t('footer.links.community'), href: '/community' },
        { name: t('footer.links.status'), href: '/status' }
      ]
    },
    legal: {
      title: t('footer.legal'),
      links: [
        { name: t('footer.links.privacy'), href: '/privacy' },
        { name: t('footer.links.terms'), href: '/terms' },
        { name: t('footer.links.cookies'), href: '/cookies' },
        { name: t('footer.links.licenses'), href: '/licenses' }
      ]
    }
  };
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__main">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <img src="/logo.png" alt="BalanzFit" className="footer__logo-icon" />
              <span className="footer__logo-text">BalanzFit</span>
            </Link>
            <p className="footer__description">
              {t('footer.description')}
            </p>
            <div className="footer__social">
              <a href="https://www.instagram.com/balanzfit/" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="18" cy="6" r="1" fill="currentColor"/>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@balanzfit" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="TikTok">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div className="footer__links">
            {Object.values(footerLinks).map((section, index) => (
              <div key={index} className="footer__column">
                <h4 className="footer__column-title">{section.title}</h4>
                <ul className="footer__column-list">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      {link.href.startsWith('/') && !link.href.startsWith('/#') ? (
                        <Link to={link.href} className="footer__link">{link.name}</Link>
                      ) : (
                        <a href={link.href} className="footer__link">{link.name}</a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        
        <div className="footer__bottom">
          <p className="footer__copyright">
            {t('footer.copyright').replace('2024', new Date().getFullYear().toString())}
          </p>
          <div className="footer__badges">
            <div className="footer__badge">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>{t('footer.badges.secure')}</span>
            </div>
            <div className="footer__badge">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>{t('footer.badges.available')}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
